import React from 'react';
import { Colors } from 'library';
import { styled, useMediaQuery } from '@mui/material';
import { track } from 'shared';
import PublicTeacherCard from './PublicTeacherCard';
import { ITeacher } from 'models';
import theme from 'theme';
import { Card, PillButton, Stack, Title } from 'library/ui';

const blurredWorkers = [
    {
        id: 1,
        name: 'Jasmine',
        pictureUrl: 'https://static.join-tandem.com/media/tandem_static/pexels-dziana-hasanbekava-7275385.jpg ',
        bio: "I'm a lead teacher with 5 years of experience. I worked with toddlers and preschoolers for 3 years and then spent some time working with infants. I'm passionate about helping children learn and grow.",
        credentials: {
            education: ["ECE-Related Associate's Degree"],
            experience: '5 years of childcare experience',
            highlights: ['Lead Teacher'],
            reviews: {
                average_score: 5.0,
                total_reviews: 3,
            },
        },
    },
    {
        id: 2,
        name: 'Helen',
        pictureUrl: 'https://static.join-tandem.com/media/tandem_static/pexels-gabby-k-5876695.jpg',
        bio: 'I have been working in childcare for 10 years. I love working with children and helping them learn and grow. I have a passion for teaching and learning.',
        credentials: {
            education: ["ECE-Related Bachelor's Degree"],
            experience: '10 years of childcare experience',
            highlights: ['Lead Teacher'],
            reviews: {
                average_score: 4.8,
                total_reviews: 10,
            },
        },
    },
    {
        id: 3,
        name: 'Jenny',
        pictureUrl: 'https://static.join-tandem.com/media/tandem_static/pexels-vinicius-wiesehofer-289347-1130626.jpg',
        bio: 'I have found that working with children is a very rewarding experience. I started working as a floater and loved seeing the children in all stages of development. I learned a lot about how to work with children of different age groups.',
        credentials: {
            education: ['CDA (Child Development Associate)'],
            experience: '3 years of childcare experience',
            highlights: ['Assistant Teacher'],
            reviews: {
                average_score: 4.5,
                total_reviews: 5,
            },
        },
    },
] as ITeacher[];

export const SeeMoreTeachers = ({ signUp, vettedWorkersCount }: { signUp: () => void; vettedWorkersCount: number }) => {
    const smDown = useMediaQuery(theme.breakpoints.down('md'));

    function shuffle(array: ITeacher[]) {
        return array.sort(() => Math.random() - 0.5);
    }

    return (
        <RelativeContainer align="center" fullWidth>
            <BlurredView />
            <SignupContainer tone="error" smDown={smDown}>
                <Stack gap="md" align="center">
                    <Title size="h1">
                        Don’t stop here—there are <span style={{ color: Colors.error }}>{vettedWorkersCount}+</span>{' '}
                        more teachers available in your area.
                    </Title>
                    <PillButton
                        onClick={() => {
                            track('Supported Region Customer Clicked Sign Up Button');
                            signUp();
                        }}
                    >
                        Create Free Account
                    </PillButton>
                </Stack>
            </SignupContainer>
            <Stack align="center" fullWidth>
                <Stack gap="sm" fullWidth>
                    {shuffle(blurredWorkers).map((worker) => (
                        <PublicTeacherCard key={worker.id} worker={worker} />
                    ))}
                </Stack>
            </Stack>
        </RelativeContainer>
    );
};

const RelativeContainer = styled(Stack)({
    position: 'relative',
    width: '100%',
});

const BlurredView = styled('div')({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backdropFilter: 'blur(10px)',
    zIndex: 10,
    width: '100%',
});

const SignupContainer = styled(Card)<{ smDown: boolean }>(({ smDown }) => ({
    position: 'absolute',
    top: 60,
    left: 140,
    right: 0,
    bottom: 0,
    zIndex: 11,
    height: 'fit-content',
    width: smDown ? '90%' : '60%',
}));
